/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_HOMEWORK_SUPPORT': {
    width: 16,
    height: 16,
    viewBox: '0 0 82.71 101.31',
    data: '<path pid="0" _fill="currentColor" d="M2.08 100.44a3.33 3.33 0 0 0 4.33-1.84l14-34.54a14.22 14.22 0 0 1 1.94-.69c.7-.2 1.42-.38 2.16-.56h35.87c-.11 4.76 3.73 11.52 5.39 15.81 2.18 5.59 4.58 11.24 6.57 16.93.89 2.56 2.36 5.95 5.37 5.75a3.33 3.33 0 0 0 1.9-.64 3.32 3.32 0 0 0 2.86-4.57l-16-39.5a70.12 70.12 0 0 0-4.36-10.77L57.4 34.16c-.66-2.25-1.24-4.51-1.75-6.62a47.51 47.51 0 0 0-4.62-11.72C48.93 11.74 48.78.56 42.86.02a4.25 4.25 0 0 0-1.06 0 3.29 3.29 0 0 0-3.53 2l-.1.25c-4.68 5.31-7.41 18.12-9.2 22.24C20.86 43.3 13.16 62.16 4.76 80.75c-1.49 3.3-6.09 10.47-4.38 15l-.13.33a3.33 3.33 0 0 0 1.83 4.36zM34.36 31.8c1.57-3.94 2.5-7.64 4.63-11.34 1-1.65 2.86-4 3.2-6.2l9.62 23.78a55.73 55.73 0 0 0 2.66 7.88 21.25 21.25 0 0 0 1.69 2.88l2.9 7.17q-2.36.13-4.73.2H40.49c-5.17-.12-10.33-.34-15.43-.54 3-7.9 6.18-15.98 9.3-23.83z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_HOMEWORK_SUPPORT.js